import styled from '@emotion/styled'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px;
  border-radius: 12px;
  background: #fff5f5;
  border: 1px solid #ffcccc;
  color: #b71c1c;

  font-size: 14px;

  @media (min-width: 480px) {
    font-size: 15px;
    padding: 14px;
  }
`

const Title = styled.span`
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
`

const Emoji = styled.span`
  font-size: 16px;
`

const Message = styled.span`
  line-height: 1.4;
`

export default function RejectedReason({ reason }) {
  return (
    <Wrapper>
      <Title>
        <Emoji>⚠️</Emoji>
        Alasan Penolakan
      </Title>
      <Message>{reason}</Message>
    </Wrapper>
  )
}
